import { Box } from '@factorialco/deprecated-design-system'

import { AllFormsDataCollection } from './AllFormsDataCollection'

export const FormsOverview = ({ trainingId }: { trainingId: string }) => {
  return (
    <Box gap="s32">
      <Box gap="s16">
        <AllFormsDataCollection trainingId={trainingId} />
      </Box>
    </Box>
  )
}
